// extracted by mini-css-extract-plugin
export default {"termsLabel":"go3vWYzVE7cyQpcKNBli","link":"pcYRF1e89Dynv8J5P1a_"};